var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"product-wishlistbutton"},[_c('b-button',{staticClass:"wishlistbutton",attrs:{"variant":_vm.link ? 'link' : 'outline-control',"size":_vm.link ? 'md' : 'sm'},on:{"click":_vm.processWishlistClick}},[_c('lazy-icon',{attrs:{"icon":_vm.wishlistIcon}}),_vm._v(" "),_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }